/* eslint-disable ember/no-classic-components */
import { tagName } from '@ember-decorators/component';
import Component from '@ember/component';

@tagName('')
export default class BlankComponent extends Component {}
